import SharedPlans from 'features/shared/Plans';

export default function Plans() {
  return (
    <div className="container-xl flex flex-col gap-8 items-center pb-9 px-5">
      <h2 className="sr-only">Plans</h2>
      <SharedPlans />
    </div>
  );
}
